export default "__VITE_ASSET__C_OFjeTs__"